<nav ngxNavbarDynamicExpand class="navbar-dark navbar-main">
    <a class="navbar-brand font-weight-bold">
        <img src="assets/img/logo_small.png" alt="logo" width="240" height="67" />
    </a>
    <div *ngIf="isAnalysisRequestPage" class="d-flex align-items-start justify-content-between" style="width: 35%">
        <div *appHasPermission="['portal.user', 'customer.admin', 'customer.user']">
            <div class="d-inline-block">
                <button class="btn-request" type="button"
                    [disabled]="uploadProgress"
                    (click)="makeUploadRequest()">
                    {{ 'CONSTANTS.BTN_REQUEST' | translate }}
                </button>
            </div>
            <div class="bubble-upload-msg" [ngClass]="{'bubble-upload-msg-hide': !isShowUploadMsg}">
                <div class="msg-div">
                    <div class="d-flex justify-content-end">
                        <i class="material-icons upload-icon" (click)="closeByBtn()">close</i>
                    </div>
                    <div class="icon-holder">
                        <i class="material-icons">cloud_upload</i>
                    </div>
                    <div class="text-center mx-2">
                        <span>{{ 'BUBBLE_MSG_UPLOAD.MSG' | translate }}</span>
                    </div>
                </div>
            </div>
            <div class="upload-block" *ngIf="uploadProgress">
                <span> {{ 'CONSTANTS.UPLOADING' | translate }}... {{ uploadProgress }}%</span>
            </div>
        </div>
      <div class="analysis-queue-section" *appHasPermission="['portal.admin', 'portal.user']">
        <h4 class="analysis-queue">Analysis Queue</h4>
        <div *ngFor="let queue of analysisQueues" class="analysis-queue-item">
          {{ queue.name }}: <span class="font-weight-bold">{{ queue.count }}</span>
        </div>
      </div>
    </div>

    <nav id="main-nav" class="navbar-internal">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <div class="item-1">
                    <div *ngIf="isAnalysisRequestPage">
                        <div *appHasPermission="['portal.admin', 'portal.user']">
                            <mat-form-field class="organization-select">
                                <!-- <mat-label>organization</mat-label> -->
                                <mat-select [(value)]="organization" class="mat-organization-select"
                                    placeholder="{{ 'NAV_BAR.ORGANIZATION' | translate | uppercase }}"
                                    (selectionChange)="organizationChanged($event)">
                                    <mat-optgroup *ngFor="let customer of organizations"
                                        [label]="customer.customerName">
                                        <mat-option *ngFor="let organization of customer.organizations"
                                            [value]="organization.organizationId">
                                            {{organization.organizationName}}
                                        </mat-option>
                                    </mat-optgroup>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </li>
            <li class="nav-item">
                <div class="item-1">
                    <a (click)="showActivityLogs()" *ngIf="isAnalysisRequestPage; else adminPages">
                        <span>
                            {{ 'NAV_BAR.ITEM_1' | translate | uppercase }}
                            <i class="material-icons">arrow_forward</i>
                        </span>
                    </a>
                    <ng-template #adminPages>
                        <a *ngIf="isUsersPanelPage()" (click)="goToCustomerPanel()">
                            <span>
                                {{ 'NAV_BAR.ITEM_4' | translate | uppercase }}
                                <i class="material-icons">arrow_forward</i>
                            </span>
                        </a>
                        <a *ngIf="isCustomersPanelPage()" (click)="goToUsersPanel()">
                            <span>
                                {{ 'NAV_BAR.ITEM_3' | translate | uppercase }}
                                <i class="material-icons">arrow_forward</i>
                            </span>
                        </a>
                    </ng-template>
                </div>
            </li>
            <li class="nav-item">
                <div class="item-2">
                    <div class="dropdown">
                        <button class="btn dropdown-toggle" type="button" id="linksDropdownMenu" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            {{ 'NAV_BAR.ITEM_2' | translate | uppercase }}
                        </button>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="linksDropdownMenu">
                            <div *ngFor="let item of items">
                            <a class="dropdown-item" [href]="item.url" target="_blank">{{ item.title }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="nav-item">
                <div class="item-3">
                    <div class="dropdown">
                        <button class="btn dropdown-toggle" title="Settings" type="button" id="settingsDropdownMenu"
                            data-toggle="dropdown" aria-expanded="false">
                            <i class="material-icons">settings</i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="settingsDropdownMenu"
                            onclick="event.stopPropagation()">
                            <a class="dropdown-item" (click)="changePass()">
                                <span>{{ 'NAV_BAR.CHANGE_PASS' | translate | uppercase }}</span>
                            </a>
                            <a class="dropdown-item" (click)="changeLang()">
                                <span>{{ 'NAV_BAR.CHANGE_LANG' | translate | uppercase }}</span>
                            </a>
                            <div class="dropdown-item" *appHasPermission="['portal.admin', 'customer.admin']">
                                <div class="custom-control custom-switch cursor">
                                    <input type="checkbox" class="custom-control-input" id="modeToggle"
                                        [(ngModel)]="selectedAdminMode" (change)="toggleClick()">
                                    <label class="custom-control-label" for="modeToggle">{{ (selectedAdminMode ?
                                        'CONSTANTS.ADMIN_MODE' : 'CONSTANTS.USER_MODE') | translate | uppercase
                                        }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="nav-item item-4">
                <span class="user-mode">{{ (selectedAdminMode ? 'CONSTANTS.ADMIN_MODE' : 'CONSTANTS.USER_MODE') |
                    translate }}</span>
                <a class="logout-block" (click)="logOut()">
                    <img class="logout-img" src="assets/img/user_logo_small.png" />
                    <span class="name-info" *ngIf="profile">{{ getUserName }}</span>
                    <span class="logout-span">{{ 'NAV_BAR.LOGOUT' | translate }}</span>
                </a>
            </li>
        </ul>
    </nav>
</nav>
<router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
<div style="font-size:small; width:100%; text-align:center; background-color: white;">Stratipath portal - version: {{
    version }}{{ branch }}</div>
<app-activity-log-modal></app-activity-log-modal>
<app-pass-changes-modal (result)="result($event)"></app-pass-changes-modal>
<app-info-modal></app-info-modal>
<app-downloading-modal></app-downloading-modal>
<app-lang-changes-modal></app-lang-changes-modal>
<!-- <app-confirm-modal title="{{ 'NAV_BAR.RESET_2FA_MODAL_TITLE' | translate }}" message="{{ 'NAV_BAR.RESET_2FA_MODAL_MSG' | translate }}"></app-confirm-modal> -->
